var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFE4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9686 10.5032L23.522 9.05664L22.0755 10.5032L20.6289 9.05664L19.1824 10.5032L17.7359 9.05664L16.2893 10.5032L14.8428 9.05664L13.3962 10.5032L11.9497 9.05664V22.5577H9.05661V25.4508C9.05661 27.0516 10.3489 28.3439 11.9497 28.3439H23.522C25.1229 28.3439 26.4151 27.0516 26.4151 25.4508V9.05664L24.9686 10.5032ZM24.4864 25.4508C24.4864 25.9812 24.0524 26.4151 23.522 26.4151C22.9916 26.4151 22.5577 25.9812 22.5577 25.4508V22.5577H13.8784V11.9497H24.4864V25.4508Z",
    fill: "#CC2525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6299 13.8789H14.8437V15.8076H20.6299V13.8789Z",
    fill: "#CC2525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5224 13.8789H21.5937V15.8076H23.5224V13.8789Z",
    fill: "#CC2525"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6299 16.7715H14.8437V18.7002H20.6299V16.7715Z",
    fill: "#CC2525"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5224 16.7715H21.5937V18.7002H23.5224V16.7715Z",
    fill: "#CC2525"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.2831,
    cy: 26.037,
    r: 7.16981,
    fill: "#FFE4E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2834 20.377C22.1532 20.377 19.623 22.9071 19.623 26.0373C19.623 29.1675 22.1532 31.6977 25.2834 31.6977C28.4136 31.6977 30.9438 29.1675 30.9438 26.0373C30.9438 22.9071 28.4136 20.377 25.2834 20.377ZM28.1136 28.0694L27.3155 28.8675L25.2834 26.8354L23.2513 28.8675L22.4532 28.0694L24.4853 26.0373L22.4532 24.0053L23.2513 23.2071L25.2834 25.2392L27.3155 23.2071L28.1136 24.0053L26.0815 26.0373L28.1136 28.0694Z",
    fill: "#CC2525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.c9d54089bfe21038b83c476dabf00d95.svg";
export { ForwardRef as ReactComponent };